import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { getPayerProductLink } from 'utils/sellables.utils'
import classNames from 'classnames'

import { EloButton } from '@elo-kit/components/elo-button/EloButton'
import { COURSE_CONTENT_CLASS_NAMES } from '@elo-kit/constants/customCss.constants'
import Award from './award.svg'
import './_product-assignment-success.scss'

@observer
class ProductAssignmentSuccess extends Component {
  render() {
    const {
      courseViewsStore: {
        sellableForSuccess,
        courseSession: { seller },
      },
    } = this.props
    const link = getPayerProductLink(sellableForSuccess, seller.username)

    return (
      <div className={classNames(COURSE_CONTENT_CLASS_NAMES.assignmentSuccessContainerClassName, 'white-widget')}>
        <img src={Award} />
        <span className='award-title'>{I18n.t('react.payer.lesson.assignment_success.award')}</span>
        <span className='award-name'>{sellableForSuccess?.name}</span>
        <EloButton href={link} className='award-link' target='_blank'>
          {I18n.t('react.payer.lesson.assignment_success.award')}
        </EloButton>
      </div>
    )
  }
}

export default ProductAssignmentSuccess
